import { useEffect, useState } from "react";
import moment from "moment";

import { Page, Container } from "@/ui/Layout/Page";
import { Grid } from "@/ui/Grid";
import { Card } from "@/ui/Card";
import { getCampaigns } from "@/api/campaigns";
import { ButtonTypes, Status } from "@/ui/types";
import { getSessionToken } from "@/api/auth";
import { Link } from "react-router-dom";
import Button from "@/ui/Button";
import { EmptyState } from "@/ui/Layout";
import { Loading } from "@/ui/Layout/Loading";

import { LAUNCH_OS_ICON } from "@/brand";
export const Broadcasts = ({ name = "" }) => {
  const [broadcastList, setBroadcastList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // get the broadcastList from the server
  const loadBroadcasts = async () => {
    const token = getSessionToken();
    const response = await getCampaigns({ token, type: "broadcast" });
    if (response) {
      // convert the response to the format that the Card components expect
      const seqs = response
        ?.filter(({ deleted }) => !deleted)
        .map((broadcast: any) => {
          return {
            id: broadcast.id,
            label: broadcast.name,
            caption: `Last Updated: ${moment(broadcast.updatedAt).fromNow()}`,
            img: (
              <img
                className="w-[42px] h-[42px] flex-none rounded-full overflow-hidden object-cover"
                src={LAUNCH_OS_ICON}
                alt=""
              />
            ), // funnel.screensnhot
            status: Status.INPROGRESS,
          };
        });

      setBroadcastList(seqs);
    }
    setIsLoading(false);
  };

  // load the broadcastList when the page loads
  useEffect(() => {
    loadBroadcasts();
  }, []);

  return (
    <Page
      topBar={{
        page: [{ label: name }],
        items: (
          <Link to="/crm/broadcasts/new" className="justify-end">
            <Button label="+ Create a Broadcast" type={ButtonTypes.OUTLINED} />
          </Link>
        ),
      }}
    >
      <Container>
        {isLoading && <Loading type="gallery" />}
        {!isLoading && !Boolean(broadcastList.length) && (
          <EmptyState
            title="No Broadcasts Yet"
            description="Get started by creating a new broadcast."
            showImage={false}
          >
            <Link to="/crm/broadcasts/new">
              <Button label="Create a Broadcast" type={ButtonTypes.DEFAULT} />
            </Link>
          </EmptyState>
        )}
        {!isLoading && Boolean(broadcastList.length) && (
           <Grid className="pb-6">
            {/* Can we change to Gallery View - let's me toggle views */}
            {broadcastList.map(
              (
                {
                  id,
                  label,
                  caption,
                  img = "[logo]",
                  status,
                  // sharedWith,
                  taskDetails,
                },
                key
              ) => {
                return (
                  <Card
                    key={key}
                    label={label}
                    caption={caption}
                    image={img}
                    href={`/crm/broadcasts/${id}`}
                    status={status}
                    taskDetails={taskDetails}
                  />
                );
              }
            )}
          </Grid>
        )}
      </Container>
    </Page>
  );
};
